import React from "react";
import prudentialIcon from "../../../../components/icon/assets/prudential-logo.svg";
import pruforceIcon from "../../../../components/icon/assets/pruforce-logo.svg";
import { CircularProgress } from "@mui/material";
import { color } from "../../../../mui-theme/palette";
import { useLogin } from "./login.hook";
import styles from "./login.module.css";
import { ErrorStateBlock } from "../../../../components/error-state/error-state";
import { getAccessibilityLabel, languageSelectionConfig } from "../../utils";
import { getItem } from "../../../../utils/local-storage";
import { DynamicLoginForm } from "../../components/login-form";
import { SSOLoginButton } from "../../components/sso-login-button/sso-login-button";
import { DynamicCreateAccountButton } from "../../components/create-account-button";

type LoginScreenProps = {};

export const LoginScreen = (props: LoginScreenProps) => {
  const {
    t,
    isCandidateWebLoginEnabled,
    region,
    setRegion,
    handleLogin,
    phoneNumber,
    setPhoneNumber,
    password,
    setPassword,
    isLoading,
    handleCreateAccount,
    handleForgetPassword,
    handleDisclaimerClick,
    handlePrivacyPolicyClick,
    islanguagePopupOpen,
    toggleLanguagePopupOpen,
    handleLanguageChange,
    enableStandardSSO,
    configLoaded,
    handleSSOLogin,
    // PHKL Custom -s
    userId,
    setUserId,
    enableCreateButton,
    setEnableCreateButton,
    // PHKL Custom -e
  } = useLogin();

  if (!configLoaded) {
    return (
      <div className={`w-screen h-screen flex flex-1 items-center justify-center`}>
        <CircularProgress sx={{ color: color.majorRed }} />
      </div>
    );
  }
  // PHKL Custom
  // return isCandidateWebLoginEnabled ? (
  return (
    <div className={styles.mainContain}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img className={styles.logo} src={pruforceIcon} alt="" />
          <span className={styles.tips}>{t("Common.pruforce_candidate_portal")}</span>
        </div>
      </div>

      <div className={styles.mainContent}>
        <div className={styles.formContainer}>
          {enableStandardSSO ? (
            <SSOLoginButton onClick={handleSSOLogin} t={t} />
          ) : (
            <>
              <DynamicLoginForm
                region={region}
                setRegion={setRegion}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                password={password}
                setPassword={setPassword}
                handleLogin={handleLogin}
                handleForgetPassword={handleForgetPassword}
                // PHKL Custom -s
                userId={userId}
                setUserId={setUserId}
                handleCreateAccount={handleCreateAccount}
                handleDisclaimerClick={handleDisclaimerClick}
                handlePrivacyPolicyClick={handlePrivacyPolicyClick}
                // PHKL Custom -e
                t={t}
              />
            </>
          )}
          {/* PHKL Custom -s */}
          {enableCreateButton && <DynamicCreateAccountButton onClick={handleCreateAccount} t={t} />}
          {/* PHKL Custom -e */}
          <div className={styles.footer}>
            <img src={prudentialIcon} alt="Prudential Icon" className={styles.prudentialIcon} />
            <div className={styles.footerText}>
              <span className={styles.disclaimer} onClick={handleDisclaimerClick}>
                {t("Common.disclaimer")}
              </span>
              <span>{t("Common.and")}</span>
              <span className={styles.privacyPolicy} onClick={handlePrivacyPolicyClick}>
                {t("Common.privacy_policy")}
              </span>
            </div>
            {/* <div className={styles.version}>{t("Common.version")} 1.0</div> PHKL Custom */}
          </div>
        </div>
        {isLoading && (
          <div className={styles.circularProgress}>
            <CircularProgress sx={{ color: color.majorRed }} />
          </div>
        )}
      </div>

      <div className={styles.headerSection}>
        <span className={styles.language}>
          {getAccessibilityLabel(getItem("i18nextLng") as string)}
        </span>
        <div className={styles.languageIcon} onClick={toggleLanguagePopupOpen}></div>{" "}
      </div>
      {islanguagePopupOpen && (
        <div className={styles.popup}>
          <ul>
            {languageSelectionConfig().availableLanguages.map((lang) => (
              <li
                key={lang.i18nLanguageCode}
                className={styles.languageItem}
                onClick={() => handleLanguageChange(lang.i18nLanguageCode)}
              >
                {lang.languageFullName}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
  // PHKL Custom s
  // ) : (
  //   <ErrorStateBlock
  //     statusCode="-1"
  //     title={t("Common.service_unavailable")}
  //     description={t("Common.the_candidate_portal_is_not_accessible")}
  //   />
  // );
  // PHKL Custom e
};
